module.exports = __webpack_public_path__ + "img/09.0ca4fe60.jpg";